import { z } from 'zod';

export const DentitionSchema = z.enum(['Permanent', 'Primary']);

export type Dentition = z.infer<typeof DentitionSchema>;
export const dentitionOptions = DentitionSchema.options;

export const SexSchema = z.enum(['Male', 'Female', 'Other']);

export type Sex = z.infer<typeof SexSchema>;
export const sexOptions = SexSchema.options;
